import type { CSSProperties } from "react";

import styles from "./ListInput.module.scss";

export interface ListOption {
  label: string;
  value: string;
}

interface ListInputProps {
  id: string;
  value: string;
  options: Array<ListOption | string>;
  placeholder?: string;
  readonly?: boolean;
  /** Inherited CSS (padding, width, etc.) */
  textStyle?: CSSProperties;
  onChange: (value: string) => void;
}

export function ListInput({
  id,
  value,
  options,
  placeholder,
  readonly,
  textStyle,
  onChange,
}: ListInputProps) {
  const inlineStyle: CSSProperties = {
    ...textStyle,
  };

  // Normalize options to ListOption format
  const normalizedOptions: ListOption[] = options.map(opt =>
    typeof opt === "string" ? { label: opt, value: opt } : opt,
  );

  return (
    <select
      id={id}
      className={styles.select}
      style={inlineStyle}
      value={value}
      disabled={readonly}
      onChange={e => onChange(e.target.value)}>
      {placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {normalizedOptions.map(opt => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
